import styled from 'styled-components'

export type CartCardProps = {
  isNavigation?: boolean
}

export const CartCard = styled.div<CartCardProps>`
  background-color: ${({ theme }) => theme?.colors?.white ?? '#FFFFFF'};
  border-radius: 4px;
  box-shadow: 0px 0px 15px #0000000d;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-bottom: 0px;
    margin-top: 0px;
  }
`

export const CardContent = styled.div<CartCardProps>`
  /* margin-right: 5px; */
  max-height: calc(100vh - 420px);
  min-height: 220px;
  padding: 20px 10px 0px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  &::-webkit-scrollbar {
    border-width: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
    border-color: #ffffff;
    border-width: 2px 2px 2px 2px;
    border-style: solid;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #c5c5c5;
    border-color: #c5c5c5;
    border-style: solid;
    border-width: 1px 8px 1px 8px;
  }
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme?.colors?.gray3};
  margin-top: 15px;
  margin-bottom: 15px;
`

export const ContentCart = styled.div`
  border: 1px solid ${({ theme }) => theme?.colors?.gray3};
  border-radius: 4px;
  /* margin-top: 15px; */
  padding: 10px;
`

export const GroupCartItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  font-family: 'Manrope', sans-serif;
`

export const HotelTitle = styled.p`
  color: ${({ theme }) => theme?.colors?.textColor};
  font-size: 13px;
  font-weight: 700;
  line-height: 10px;
  max-width: 188px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const Icon = styled.img`
  height: 12px;
`

export const TextCity = styled.p`
  color: ${({ theme }) => theme?.colors?.gray5} !important;
  font-size: 11px;
  margin-top: 2px !important;
`

export const ContainerItems = styled.div``

export const EmptyCartMessageContainer = styled.div`
  text-align: center;
  vertical-align: center;
  height: 110px;
  display: flex;

  p {
    color: ${({ theme }) => theme?.colors?.gray6};
    align-self: center;
  }
`

export const IconRoom = styled.img`
  border-radius: 4px;
  height: 40px;
  width: 40px;
`

export const AlertRoomsCount = styled.div`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin: 15px 10px 0px 10px;
    background-color: #e7f3fb;
    border-radius: 4px;
    height: 36px;
    p {
      margin: 0;
      color: ${({ theme }) => theme?.colors?.info} !important;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
    }
  }
`

export const CartTotalContainer = styled.div`
  margin-top: 20px;
`
